/* Presentation only: no business state, no inferred cart success. */
(function () {
  'use strict';

  var NAME = 'MNLPdpMotionV1535';
  if (window[NAME]) { window[NAME].refresh(); return; }
  var MAX_H = 900;
  var PRESS_SEL = [
    '.mnl-atc', '.mnl-sticky-atc__btn', '.mnl-pp3-atc-hero__btn', '.mnl-pp3-cta__btn',
    '.mnl-flavor', '.mnl-int', '.mnl-fmt', '.mnl-pw__sport-btn', '.mnl-preset-btn',
    '.mnl-presets__btn', '.mnl-mode-choice__btn', '.mnl-conf-tool',
    '.mnl-obj-act__row', '.mnl-step__head', '.mnl-obj__expand',
    '.mnl-cfsw', '.mnl-nocaf-card', '.mnl-pp3-gal__nav', '.mnl-pp3-gal__sarrow',
    '.mnl-pp3-gal__thumb', '.mnl-pp3-faq-filter', '.mnl-pp3-faq__q', '.mnl-pp3 [role="tab"]'
  ].join(',');
  var RANGE_SEL = '#mnl-overlay input.mnl-obj__slider, #mnl-overlay input.mnl-obj-act__slider, #mnl-overlay input.mnl-slider, #mnl-overlay #mnl-doses-slider';
  var TEXT_SEL = '.mnl-price-block__main, .mnl-price-block__net, .mnl-doses-price, .mnl-doses-count, #mnl-side-r-format, #mnl-side-r-flavor, #mnl-side-r-caf, #mnl-side-r-actifs, #mnl-side-r-actifs-list';
  var observed = new Map();
  var structures = new Map();
  var pending = new Map();
  var animations = new Map();
  var flags = new Map();
  var timers = new Set();
  var frames = new Set();
  var listeners = [];
  var unloaded = new Set();
  var dragValues = new Map();
  var lastValues = new WeakMap();
  var lastEdges = new WeakMap();
  var dragging = null;
  var pressTimer = 0;
  var dragTimer = 0;
  var keyTimer = 0;
  var refreshFrame = 0;
  var lastEdgeAt = -Infinity;
  var suspended = false;
  var destroyed = false;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduced = !!(mq && mq.matches);

  function closest(node, selector) { return node && node.closest ? node.closest(selector) : null; }
  function text(node) { return (node.textContent || '').replace(/\s+/g, ' ').trim(); }
  function known(value) { return value !== '' && value !== '—'; }
  function excluded(node) {
    var found = false;
    unloaded.forEach(function (root) { if (root === node || root.contains(node)) found = true; });
    return found;
  }
  function canPresent(node) {
    if (destroyed || suspended || reduced || document.hidden || !node || !node.isConnected || excluded(node)) return false;
    if (closest(node, '[hidden], [inert], [aria-hidden="true"]')) return false;
    try { return node.offsetHeight > 0 && node.offsetHeight <= MAX_H && node.getClientRects().length > 0; }
    catch (_) { return false; }
  }
  function enabled(node) { return node && !node.disabled && !closest(node, '[disabled], [aria-disabled="true"], [aria-busy="true"]'); }
  function later(callback, delay) {
    var id = window.setTimeout(function () { timers.delete(id); if (!destroyed) callback(); }, delay);
    timers.add(id); return id;
  }
  function clearTimer(id) { if (id) { window.clearTimeout(id); timers.delete(id); } }
  function frame(callback) {
    var id = window.requestAnimationFrame(function () { frames.delete(id); if (!destroyed) callback(); });
    frames.add(id); return id;
  }
  function clearFrame(id) { if (id) { window.cancelAnimationFrame(id); frames.delete(id); } }
  function flag(node, name, value) {
    if (!node) return;
    node.setAttribute(name, value || '');
    if (!flags.has(node)) flags.set(node, new Set());
    flags.get(node).add(name);
  }
  function unflag(node, name) {
    node.removeAttribute(name);
    if (flags.has(node)) {
      flags.get(node).delete(name);
      if (!flags.get(node).size) flags.delete(node);
    }
  }
  function clearFlags(name) {
    flags.forEach(function (names, node) {
      Array.from(names).forEach(function (key) { if (!name || key === name) unflag(node, key); });
    });
  }
  function cancelAnimation(node) {
    var animation = animations.get(node);
    if (animation) { animations.delete(node); animation.cancel(); }
  }
  function cancelPulse(node) {
    var task = pending.get(node);
    if (task) { clearFrame(task.id); pending.delete(node); }
    cancelAnimation(node);
  }
  function pulse(node, expected) {
    if (!canPresent(node) || typeof node.animate !== 'function' || (document.activeElement && node.contains(document.activeElement))) return;
    cancelPulse(node);
    var task = { id: 0, expected: expected };
    task.id = frame(function () {
      if (pending.get(node) !== task) return;
      pending.delete(node);
      if (!canPresent(node) || text(node) !== task.expected || (document.activeElement && node.contains(document.activeElement))) return;
      try {
        var animation = node.animate([{ opacity: .68 }, { opacity: 1 }], { duration: 200, easing: 'ease-out' });
        animations.set(node, animation);
        Promise.resolve(animation.finished).then(function () {
          if (animations.get(node) === animation) animations.delete(node);
        }, function () {
          if (animations.get(node) === animation) animations.delete(node);
        });
      } catch (_) {}
    });
    pending.set(node, task);
  }
  function syncNode(node, entry) {
    if (destroyed || suspended || observed.get(node) !== entry) return;
    if (!node.isConnected || excluded(node)) { entry.observer.disconnect(); observed.delete(node); cancelPulse(node); return; }
    var next = text(node), previous = entry.value;
    if (next === previous) return;
    entry.value = next;
    if (!dragging && known(previous) && known(next)) pulse(node, next);
  }
  function syncValues() { observed.forEach(function (entry, node) { entry.value = text(node); }); }
  function queueRefresh() {
    if (refreshFrame || suspended || destroyed || reduced || document.hidden) return;
    refreshFrame = frame(function () { refreshFrame = 0; refresh(); });
  }
  function refresh() {
    if (suspended || destroyed || !window.MutationObserver) return;
    observed.forEach(function (entry, node) {
      if (!node.isConnected || excluded(node)) { entry.observer.disconnect(); observed.delete(node); cancelPulse(node); }
    });
    structures.forEach(function (observer, root) {
      if (!root.isConnected || excluded(root)) { observer.disconnect(); structures.delete(root); }
    });
    flags.forEach(function (_, node) { if (!node.isConnected || excluded(node)) Array.from(flags.get(node)).forEach(function (name) { unflag(node, name); }); });
    pending.forEach(function (_, node) { if (!node.isConnected || excluded(node)) cancelPulse(node); });
    animations.forEach(function (_, node) { if (!node.isConnected || excluded(node)) cancelAnimation(node); });
    if (reduced || document.hidden) return;
    document.querySelectorAll(TEXT_SEL).forEach(function (node) {
      if (observed.has(node) || excluded(node)) return;
      var entry = { value: text(node), observer: null };
      entry.observer = new MutationObserver(function () { syncNode(node, entry); });
      entry.observer.observe(node, { childList: true, characterData: true, subtree: true });
      observed.set(node, entry);
      var root = closest(node, '#mnl-overlay, .mnl-pp3');
      if (root && !structures.has(root)) {
        var observer = new MutationObserver(function (records) {
          if (!root.isConnected || records.some(function (record) {
            return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (item) { return item.nodeType === 1; });
          })) queueRefresh();
        });
        observer.observe(root, { childList: true, subtree: true });
        structures.set(root, observer);
      }
    });
  }
  function releasePress() { clearTimer(pressTimer); pressTimer = 0; clearFlags('data-mnl-press'); }
  function armWatchdog() { clearTimer(dragTimer); dragTimer = later(function () { endDrag(false); }, 2500); }
  function startDrag(range) {
    if (!canPresent(range) || !enabled(range)) return;
    if (dragging === range) { armWatchdog(); return; }
    if (dragging) endDrag(true);
    dragging = range;
    dragValues.clear();
    observed.forEach(function (entry, node) { dragValues.set(node, entry.value); });
    lastValues.set(range, range.value);
    flag(range, 'data-mnl-drag');
    var companion = closest(range, '.mnl-obj-act__row, .mnl-obj, .mnl-doses-block');
    if (canPresent(companion)) flag(companion, 'data-mnl-drag');
    document.querySelectorAll('#mnl-overlay .mnl-price-block').forEach(function (block) { if (canPresent(block)) flag(block, 'data-mnl-live'); });
    armWatchdog();
  }
  function endDrag(silent) {
    clearTimer(dragTimer); dragTimer = 0;
    clearTimer(keyTimer); keyTimer = 0;
    if (!dragging) return;
    dragging = null;
    clearFlags('data-mnl-drag'); clearFlags('data-mnl-live');
    observed.forEach(function (entry, node) {
      var next = text(node), previous = dragValues.get(node);
      entry.value = next;
      if (!silent && previous !== undefined && previous !== next && known(previous) && known(next)) pulse(node, next);
    });
    dragValues.clear();
  }
  function rangeFrom(node) { var range = closest(node, RANGE_SEL); return range && range.type === 'range' ? range : null; }
  function onPointerDown(event) {
    var range = rangeFrom(event.target);
    if (range) { startDrag(range); return; }
    var node = closest(event.target, PRESS_SEL);
    if (!canPresent(node) || !enabled(node)) return;
    releasePress(); flag(node, 'data-mnl-press'); pressTimer = later(releasePress, 900);
  }
  function onInput(event) {
    var range = rangeFrom(event.target);
    if (!range || !canPresent(range) || !enabled(range)) return;
    if (!dragging) startDrag(range); else if (dragging !== range) return;
    armWatchdog();
    var previous = lastValues.get(range), current = range.value;
    lastValues.set(range, current);
    if (current === previous) return;
    var value = Number(current), min = Number(range.min), max = Number(range.max);
    var edge = value <= min ? 'min' : value >= max ? 'max' : '';
    if (lastEdges.get(range) === edge) return;
    lastEdges.set(range, edge);
    if (!edge) { unflag(range, 'data-mnl-edge'); return; }
    if (Date.now() - lastEdgeAt < 400) return;
    lastEdgeAt = Date.now(); flag(range, 'data-mnl-edge', edge);
    later(function () { unflag(range, 'data-mnl-edge'); }, 260);
  }
  function onKeyDown(event) {
    var range = rangeFrom(event.target);
    if (!range || ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown'].indexOf(event.key) < 0) return;
    startDrag(range); clearTimer(keyTimer); keyTimer = later(function () { endDrag(false); }, 420);
  }
  function stopTransient() {
    releasePress(); endDrag(true);
    frames.forEach(function (id) { window.cancelAnimationFrame(id); }); frames.clear(); pending.clear(); refreshFrame = 0;
    animations.forEach(function (animation) { animation.cancel(); }); animations.clear();
    timers.forEach(function (id) { window.clearTimeout(id); }); timers.clear();
    clearFlags(); syncValues();
  }
  function disconnect() {
    observed.forEach(function (entry) { entry.observer.disconnect(); }); observed.clear();
    structures.forEach(function (observer) { observer.disconnect(); }); structures.clear();
  }
  function listen(target, type, callback) {
    target.addEventListener(type, callback, { passive: true });
    listeners.push(function () { target.removeEventListener(type, callback); });
  }
  function onMotionChange() { reduced = !!mq.matches; stopTransient(); if (!reduced) refresh(); }
  function onSectionUnload(event) { unloaded.add(event.target); stopTransient(); refresh(); }
  function onSectionLoad(event) {
    unloaded.forEach(function (root) { if (!root.isConnected || root === event.target || event.target.contains(root)) unloaded.delete(root); });
    refresh();
  }
  function destroy() {
    if (destroyed) return;
    stopTransient(); disconnect(); destroyed = true;
    listeners.forEach(function (remove) { remove(); }); listeners = [];
    if (mq && mq.removeEventListener) mq.removeEventListener('change', onMotionChange);
    else if (mq && mq.removeListener) mq.removeListener(onMotionChange);
    unloaded.clear();
    if (window[NAME] === api) delete window[NAME];
  }
  var api = { refresh: refresh, destroy: destroy };
  window[NAME] = api;
  if (mq && mq.addEventListener) mq.addEventListener('change', onMotionChange);
  else if (mq && mq.addListener) mq.addListener(onMotionChange);
  listen(document, 'pointerdown', onPointerDown);
  listen(window, 'pointerup', function () { releasePress(); endDrag(false); });
  listen(window, 'pointercancel', stopTransient);
  if (!('PointerEvent' in window)) {
    listen(document, 'touchstart', onPointerDown); listen(document, 'mousedown', onPointerDown);
    listen(window, 'touchend', function () { releasePress(); endDrag(false); });
    listen(window, 'mouseup', function () { releasePress(); endDrag(false); });
    listen(window, 'touchcancel', stopTransient);
  }
  listen(document, 'input', onInput);
  listen(document, 'change', function (event) { if (rangeFrom(event.target)) endDrag(false); });
  listen(document, 'keydown', onKeyDown);
  listen(document, 'focusin', stopTransient);
  listen(window, 'blur', stopTransient);
  listen(document, 'visibilitychange', function () { stopTransient(); if (!document.hidden) refresh(); });
  listen(window, 'pagehide', function (event) { if (event.persisted) { stopTransient(); suspended = true; disconnect(); } else destroy(); });
  listen(window, 'pageshow', function () { if (suspended) { suspended = false; refresh(); } });
  listen(document, 'shopify:section:unload', onSectionUnload);
  listen(document, 'shopify:section:load', onSectionLoad);
  if (document.readyState === 'loading') listen(document, 'DOMContentLoaded', refresh);
  else refresh();
  if (!reduced && !document.hidden) later(refresh, 2500);
})();
